<template>
  <div v-show="showRequestForm">
    <h3>Форма заявки</h3>
    <div class="fl threeInLine">
      <formInput :refs="'LAST_NAME'" :form="'request'"></formInput>
      <formInput :refs="'FIRST_NAME'" :form="'request'"></formInput>
      <formInput :refs="'SECOND_NAME'" :form="'request'"></formInput>
    </div>

    <div class="fl frstShortSeconLong">
      <div>
        <div>
          <label class="fl checkBoxLabel">
            <input type="checkbox" v-model="IS_ADDRESS_COINCIDES" true-value="Y" false-value="N">
            <span>Адрес регистрации совпадает с адресом проживания</span>
          </label>
        </div>
        <div class="fl adressCheck">
          <div class="button" v-on:click="checkThisAdress">Проверить адрес</div>
          <div v-html="resultAdresCheck"></div>
        </div>
        <label class="fl checkBoxLabel" v-if="scronigInputVisible"
               style="margin-top: 10px;cursor: pointer;opacity: 0;pointer-events: none;">
          <input type="checkbox" v-model="VIDEO_SCORING" >
          <span>Согласен на видео звонок</span>
        </label>
      </div>
      <div>
        <DadataSuggest :refs="'RESIDENTIAL_ADDRESS'"
                   :form="'request'"
        ></DadataSuggest>

        <DadataSuggest :refs="'REGISTRATION_ADDRESS'"
                   :form="'request'"
                   v-bind:class="{blockThisInput: dontTouchThisShit}"
        ></DadataSuggest>
      </div>
    </div>

    <div class="fl threeInLine">
      <div>
        <h3>Паспортные данные:</h3>
        <formInput  :refs="'PASSPORT_SERIES'"  :form="'request'"></formInput>
        <formInput  :refs="'PASSPORT_NUMBER'"  :form="'request'"></formInput>
        <formInput  :refs="'PASSPORT_DATE'" :form="'request'"></formInput>
        <formInput  :refs="'PASSPORT_DEP_CODE'" :form="'request'"></formInput>
        <DadataSuggestPassport :refs="'PASSPORT_DEP'"
                               :form="'request'"></DadataSuggestPassport>
      </div>
      <div>
        <h3>Данные клиента:</h3>
        <formInput :refs="'BIRTHDAY'" :form="'request'"></formInput>
        <formInput  :refs="'BIRTHPLACE'" :form="'request'"></formInput>
        <formSelect :refs="'GENDER'" :form="'request'"></formSelect>
        <formInput :refs="'EMAIL'" :form="'request'"></formInput>
        <formInput :refs="'PHONE'" :form="'request'"></formInput>
      </div>
      <div>
        <h3>Источник дохода:</h3>
        <formInput :refs="'WORK_JOB'" :form="'request'"></formInput>
        <DadataSuggest :refs="'WORK_TITLE'" :form="'request'"></DadataSuggest>
        <formSelect :refs="'EXPER_RADIO'" :form="'request'"></formSelect>
        <formInput :refs="'CONST_INCOME'" :form="'request'"></formInput>
        <formInput :refs="'OTHER_SOURCES_OF_INCOME'" :form="'request'"></formInput>
        <formSelect :refs="'CREDHISTORY_RADIO'" :form="'request'"></formSelect>
      </div>
    </div>
    <hr>
    <div class="fl threeInLine">
      <div>
        <formInput :refs="'CAR_NUMBER'" :form="'request'" v-if="valueVuex.request.PRODUCT_ID == 'A'"></formInput>
      </div>
      <div v-show="false">
        <formInput :refs="'MEETING_DATE'" :form="'request'"></formInput>
        <formInput :refs="'MEETING_HOUR'" :form="'request'"></formInput>
      </div>
      <div id="saveRequestWrap">
        <div class="button" v-on:click="saveRequest(false)" v-if="buttons.request">Сохранить заявку</div>
        <div class="button" v-on:click="saveRequest(isAutoForm)" v-if="isAutoForm">Сохранить заявку и всать на паузу</div>


          <div class="button" v-on:click="saveRequest2" v-if="buttons.redirect">Сохранить заявку и перевести звонок на агента</div>
          <div class="button" v-on:click="saveRequest(false)" v-if="buttons.redirect">Сохранить заявку без
            перевода звонка</div>
          <div class="button" v-on:click="newLead" v-if="buttons.next">Продолжить работу</div>

      </div>
    </div>
    <div style="height: 150px"></div>
    <div style="height: 20px;border-top: 1px solid #c2c2c2" v-on:click="cdButtonState('redirectReady')"></div>
  </div>
</template>

<script>

  import longFormField from '@/gavnoCode/longFormField';
  import longFormOption from '@/gavnoCode/longFormOptions';
  import FormFieldCheck from '@/gavnoCode/requestFormFieldCheck';
  import {mapGetters, mapState} from 'vuex';

  const buttonState = () => {
    return {
      request:true,
      redirect:false,
      next:false,
    }
  };

  export default {
    name: "formRequest",
    components: {
      formInput: () => import('@/components/forms/formInput'),
      DadataSuggest: () => import('@/components/forms/dadataSuggest'),
      DadataSuggestPassport: () => import('@/components/forms/dadataSuggestPassport'),
      formSelect: () => import('@/components/forms/formSelect')
    },
    props: {
      calcSumm: {
        type: Number,
        default: 44000
      }
    },
    data: function () {
      return {
        requestForm: longFormField,
        requestFormOption: longFormOption,
        residentalSuggestValue: [],
        registrationSuggestValue: [],
        resultAdresCheck: '',
        isAutoForm:false,
        scronigInputVisible:false,
        buttons: buttonState(),
      }
    },
    methods: {
      newLead(){
        this.buttons = buttonState();
        this.$emit('loadNewLead');
      },
      cdButtonState(action){
        switch (action) {
          case 'redirectReady':
            this.buttons.request = false;
            this.buttons.redirect = true;
            this.buttons.next = false;
            break;
          case 'redirectInAction':
            this.buttons.request = false;
            this.buttons.redirect = false;
            this.buttons.next = true;
            break;
          case 'defaultSave':
            this.buttons.request = true;
            this.buttons.redirect = false;
            this.buttons.next = false;
            break;
        }
      },
      redirectToAgent(){
        this.$myApi.singleRequest({
          action: 'asterisk_testRedirectFromCCToAgent',
        }).then((res)=>{
          // Происходит соединение с Агентом. Сообщите Агенту номер телефона для связи с клиентом.
          console.log(res);
          this.$store.commit('setContent', 'Происходит соединение с Агентом. Сообщите Агенту номер телефона для связи с клиентом.');
          this.$store.commit('showModal');
        }).catch((res)=>{
          console.log(res)
        })
      },
      saveRequest2:function(isAutoForm){
        this.cdButtonState('redirectInAction');
        if (this.canSaveRequest) {
          this.$store.dispatch('isAdressConsides');
          let SendData = {
            data:Object.assign({}, this.valueVuex),
            action:'Operator_saveStatus'
          };

          if (this.valueVuex['request']['WHERE_TO_FIND_US'].length == 0 && this.valueVuex['status']['requestType'] == 'Incoming') {
            window.scrollTo(0,0);
            this.$store.commit('setContent', 'Не заполнено поле "Откуда о нас узнали"');
            this.$store.commit('showModal');
            return false;
          }

          this.$store.commit('setContent', 'Сохранение заявки, ожидайте');
          this.$store.commit('showModal');

          this.$myApi.SendRequest(SendData, this, 'saveStatus', true).then((result) => {
            console.log('1')
            // this.$store.commit('hideModal');
            this.redirectToAgent();
            // if (isAutoForm) {
              // this.$emit('loadNewLeadWithPause');
            // } else if(this.VIDEO_SCORING){
            //   // console.log(result);
            //   // localStorage.setItem('leadInfo', '');
            //   // localStorage.removeItem('leadInfoTimeUpdate');
            //   // this.$router.push('/vdscr');
            //   //если вернем обратно, нужно загрузку лида убрать
            //   this.$emit('loadNewLead');
            //
            // } else{
            //   this.$emit('loadNewLead');
            // }
            // это для теста
            // this.getDemand()
            // .then(this.canRedirectToAgent)
            //   .then(res=>{
            //     console.log(this.$store.getters.getDemandIdMsg)
            //   })
            //   .catch(res=>{
            //     this.loadNewLead(isAutoForm);
            //   });
          }).catch((msg) => {
            this.$store.commit('setContent', msg);
            this.$store.commit('showModal');
          });
        } else {
          console.log('canselSave');
          let input = document.getElementsByTagName('input');
          let selectArr = document.getElementsByTagName('select');
          for(let i=0;i<input.length;i+=1){
            let click = true;
            if(
              input[i].getAttribute('name') == 'PASSPORT_DEP'
              || input[i].getAttribute('name') == 'RESIDENTIAL_ADDRESS'
              || input[i].getAttribute('name') == 'REGISTRATION_ADDRESS'
            ) {
              if (input[i].value.length > 0) {
                click = false;
              }
            }
            if (click) {
              input[i].focus();
              input[i].blur();
            }
          }
          for(let i=0;i<selectArr.length;i+=1){
            selectArr[i].focus();
            selectArr[i].blur();
          }
          this.cdButtonState('redirectReady');
        }
      },
      setMeetingDate: function (Today) {
        let date = new Date(Today.getTime() + 1000 * 60 * 60 * 24);
        let day = date.getDate();
        let month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
        day = day < 10 ? '0' + day : day;
        let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        return {
          MEETING_DATE:date.getFullYear() + '-' + month + '-' + day,
          MEETING_HOUR: h + ':' + m
        };
      },
      checkThisAdress: function () {
        let sendData = {
          action: 'Operator_GetAddressTerritory',
          Address: this.valueVuex['request']['RESIDENTIAL_ADDRESS'],
          RESIDENTIAL_ADDRESS_DADATA: this.valueVuex['request']['RESIDENTIAL_ADDRESS_DADATA'],
        };
        this.resultAdresCheck = '<span style="">Идёт провека адреса</span>';
        this.$myApi.SendRequest(sendData, this, 'checkThisAdress', false).then((result) => {
          this.resultAdresCheck = '<span style="color:green">Адрес зонируется</span>';
          try {
            this.$store.dispatch('saveSendData',{
              target:'VIDEO_SCORING_AVAILABILITY',
              form:'request',
              value: result.VideoScorGR
            });
          } catch (e) {
            console.log(e);
          }
          if (result.VideoScorGR > 0) {
            // this.$store.commit('saveSendData',{
            //   form:'request',
            //   target:'VIDEO_SCORING',
            //   value:true,
            // });
            this.scronigInputVisible = true;
          }else {
            this.scronigInputVisible = false;
            // this.$store.commit('saveSendData',{
            //   form:'request',
            //   target:'VIDEO_SCORING',
            //   value:false,
            // });
          }
          if (result.CanRedirectCO > 0) {
            this.cdButtonState('redirectReady');
          } else {
            this.cdButtonState('defaultSave');
          }
        }).catch((msg) => {
          this.resultAdresCheck = '<span style="color:red">Адрес не попадает ни в один участок</span>';
        });
      },
      getDemand(){
        return new Promise((resolve, reject) => {
          if (this.vdscr.demandRequestGuid.length > 0) {
            this.$myApi.GetRequestResult(this.vdscr.demandRequestGuid,this)
            .then(res=>{
              this.$store.dispatch('saveDemand',res[0].Demid)
              .then(()=>{ resolve();})
              .catch(()=>{ reject();});
            }).catch(res=>{
              res['ads']='';
              reject();
            });
          } else {
            reject();
          }
        });
      },
      loadNewLead(isAutoForm){
        if (isAutoForm) {
          alert('this.$emit(\'loadNewLeadWithPause\')')
          // this.$emit('loadNewLeadWithPause');
        } else if(this.VIDEO_SCORING){
          // console.log(result);
          // localStorage.setItem('leadInfo', '');
          // localStorage.removeItem('leadInfoTimeUpdate');
          // this.$router.push('/vdscr');
          //если вернем обратно, нужно загрузку лида убрать
          alert('this.$emit(\'loadNewLead\');');
          // this.$emit('loadNewLead');
        } else{
          alert('this.$emit(\'loadNewLead\');')
          // this.$emit('loadNewLead');
        }
      },
      canRedirectToAgent(){
        return new Promise(((resolve, reject) => {
          if (parseInt(this.$store.getters.getDemandIdMsg, 10) > 0 ) {
            let SendData = {
              action:'Operator_canRedirectToAgent',
              demand : this.$store.getters.getDemandIdMsg
            };
            this.$myApi.SendRequest(SendData, this, 'canRedirectToAgent', false)
              .then((res)=>{
                console.log(res);
              })
              .catch((res)=>{
                console.log(res);
                reject();
              })
          } else {
            reject();
          }
        }));
      },
      saveRequest:function(isAutoForm){
        if (this.canSaveRequest) {
          this.$store.dispatch('isAdressConsides');
          let SendData = {
            data:Object.assign({}, this.valueVuex),
            action:'Operator_saveStatus'
          };

          if (this.valueVuex['request']['WHERE_TO_FIND_US'].length == 0 && this.valueVuex['status']['requestType'] == 'Incoming') {
            window.scrollTo(0,0);
            this.$store.commit('setContent', 'Не заполнено поле "Откуда о нас узнали"');
            this.$store.commit('showModal');
            return false;
          }

          this.$store.commit('setContent', 'Сохранение заявки, ожидайте');
          this.$store.commit('showModal');



          this.$myApi.SendRequest(SendData, this, 'saveStatus', true).then((result) => {
            this.$store.commit('hideModal');
            if (isAutoForm) {
              this.$emit('loadNewLeadWithPause');
            } else if(this.VIDEO_SCORING){
              // console.log(result);
              // localStorage.setItem('leadInfo', '');
              // localStorage.removeItem('leadInfoTimeUpdate');
              // this.$router.push('/vdscr');
              //если вернем обратно, нужно загрузку лида убрать
              this.$emit('loadNewLead');

            } else{
              this.$emit('loadNewLead');
            }
            // это для теста
            // this.getDemand()
            // .then(this.canRedirectToAgent)
            //   .then(res=>{
            //     console.log(this.$store.getters.getDemandIdMsg)
            //   })
            //   .catch(res=>{
            //     this.loadNewLead(isAutoForm);
            //   });
          }).catch((msg) => {
            this.$store.commit('setContent', msg);
            this.$store.commit('showModal');
          });
        } else {
          console.log('canselSave');
          let input = document.getElementsByTagName('input');
          let selectArr = document.getElementsByTagName('select');
          for(let i=0;i<input.length;i+=1){
            let click = true;
            if(
              input[i].getAttribute('name') == 'PASSPORT_DEP'
              || input[i].getAttribute('name') == 'RESIDENTIAL_ADDRESS'
              || input[i].getAttribute('name') == 'REGISTRATION_ADDRESS'
            ) {
              if (input[i].value.length > 0) {
                click = false;
              }
            }
            if (click) {
              input[i].focus();
              input[i].blur();
            }
          }
          for(let i=0;i<selectArr.length;i+=1){
            selectArr[i].focus();
            selectArr[i].blur();
          }
        }
      },
      checkThisField: function (inputValue,refs) {
        let statusArr = {};
        if (typeof FormFieldCheck[refs] == 'function') {
          statusArr = FormFieldCheck[refs](inputValue, this);
        } else {
          statusArr = FormFieldCheck.isEmpty(inputValue);
        }
        return statusArr;
      }
    },
    computed: {
      dontTouchThisShit: function () {
        if (this.IS_ADDRESS_COINCIDES === 'Y') {
          this.$store.dispatch('isAdressConsides');
          return true;
        }
        return false;
      },
      IS_ADDRESS_COINCIDES:{
        get(){
          return this.valueVuex['request']['IS_ADDRESS_COINCIDES'];
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'IS_ADDRESS_COINCIDES',
            form:'request',
            value: value
          });
        }
      },
      VIDEO_SCORING:{
        get(){
          return this.valueVuex['request']['VIDEO_SCORING'];
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'VIDEO_SCORING',
            form:'request',
            value: value
          });
        }
      },
      ...mapState({
        valueVuex: state => state.requestField.sendData,
        statusVuex: state => state.requestField.workData,
        vdscr:state=>state.requestField.videoScoring,
      }),
      ...mapGetters(['canSaveRequest']),
      showRequestForm:function(){
        return this.valueVuex['status']['CallStatus'] === 'Оформлена заявка';
      }
    },
    watch: {
    },
    mounted() {
      //мутим воду, если открыта форма заявки
      let Today = new Date();
      this.$store.dispatch('setRequestField',{
        form:'request',
        values:this.setMeetingDate(Today)
      });
      this.isAutoForm = this.$route.path == '/autoCC';


    }
  }
</script>

<style scoped>


  .checkBoxLabel {
    align-items: center
  }

  .checkBoxLabel span {
    display: inline-block;
    width: calc(100% - 20px);
  }

  .blockThisInput {
    opacity: 0.3;
    pointer-events: none
  }

  .adressCheck {
    align-items: center;
    padding-top: 10px;
  }

  #saveRequestWrap {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
  }
</style>
